import axios from "axios";
import { Config } from "../config";
import { useMutation, useQuery } from "react-query";

const userBaseURL = Config.serviceUrls.userBaseUrl;

const CREDENTIAL_MASTER_QUERY_KEY = "/CredentialMaster/GetAllByOwnerId";

/**
 * Builds the GetAllByOwnerId query string. `type` is omitted when empty so
 * the picker can load every credential name for the owner.
 * @param {string|number} ownerId
 * @param {string|number} [type]
 * @returns {string}
 */
function buildCredentialNameListUrl(ownerId, type) {
  const params = new URLSearchParams({ ownerId: String(ownerId ?? "") });
  if (type !== undefined && type !== null && type !== "") {
    params.append("type", String(type));
  }
  return `${userBaseURL}/CredentialMaster/GetAllByOwnerId?${params.toString()}`;
}

export async function getCredentialNameListByOwnerId(ownerId = "", type = "") {
  const response = await axios.get(buildCredentialNameListUrl(ownerId, type));
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data.data;
}

export function useGetCredentialNameListByOwnerId(ownerId, type, options = {}) {
  return useQuery(
    [CREDENTIAL_MASTER_QUERY_KEY, ownerId, type ?? ""],
    () => getCredentialNameListByOwnerId(ownerId, type),
    {
      enabled: !!ownerId,
      ...options,
    },
  );
}

export async function addCredentialName(params) {
  const response = await axios.post(`${userBaseURL}/CredentialMaster`, params);
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
}

export function useAddCredentialNameMutation() {
  return useMutation((params) => addCredentialName(params));
}

export async function editCredentialName(params) {
  const response = await axios.put(`${userBaseURL}/CredentialMaster`, params);
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
}

export function useEditCredentialNameMutation() {
  return useMutation((params) => editCredentialName(params));
}

export async function deleteCredentialName(params) {
  const response = await axios.delete(`${userBaseURL}/CredentialMaster`, {
    data: params,
  });
  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }
  return response.data;
}

export function useDeleteCredentialNameMutation() {
  return useMutation((params) => deleteCredentialName(params));
}

export async function getCredentialNameById(credentialNameId) {
  const response = await axios.get(
    `${userBaseURL}/CredentialMaster/${credentialNameId}`,
  );

  if (response.data.statusCode !== 200) {
    throw new Error(response?.data?.message);
  }

  return response?.data;
}

export { CREDENTIAL_MASTER_QUERY_KEY };
